<script setup>
let cardCourseGenreData = null;
const { getCardCourseGenre } = useCardCourseGenreData();
const { data: cardCourseGenre } = await getCardCourseGenre();
cardCourseGenreData = cardCourseGenre.value.cardCourseGenre;
const filterCourses = (genre) => {
  const interest = useInterest();
  interest.update(genre);
  const router = useRouter()
  router.push('/courses')
}
</script>

<template>
  <div class="block card-course-genre">
    <div class="container">
      <div class="row justify-content-center">
        <div :class="['col-12', cardCourseGenreData.length <=3 ? 'col-sm-4': 'col-sm-3']" v-for="card in cardCourseGenreData">
          <div class="card-course-genre-container">
            <NuxtImg :src="card.cardImage.url" class="card-image" />
            <article class="card-content" v-html="card.cardDescription"></article>
            <div class="ctaWrapper">
              <a class="btn btn-primary" @click="filterCourses(card.genre.typeString)">{{ card.ctaTitle }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .card-course-genre {
    // Selecting all card containers as they are columns
    [class*=" col-"]{
      margin-bottom: 10px;
      @include media-breakpoint-up(lg) {
        margin-bottom: 0;
      }
    }
    .card-course-genre-container {
      height: 100%;
      overflow: hidden;
      border-radius: 24px;
      border: solid 1px $color-light-gray;
      .card-image{
        max-width: 100%;
        margin: 0 auto;
        display: block;
      }
      .card-content {
        display: block;
        margin-top: 20px;
        padding: 0 20px;
        font-size: $font-size-base;
      }
      .ctaWrapper {
        padding: 15px;
        .btn {
          width: 100%;
        }
      }
    }
  }
</style>